import React, { useState,useEffect } from "react";
import { AlertTriangle, Bell } from "lucide-react";
import redirectURL from "../redirectURL"
import "../../assets/css/inventorymanagement.css"
import SweetAlert from "react-bootstrap-sweetalert";


const AlertsSettings = () => {
  const [thresholds, setThresholds] = useState({
    lowStock: 20,
    inTransitLimit: 75,
    delayTolerance: 24,
    forecastAccuracy: 85,
  });

  const [alertToggles, setAlertToggles] = useState({
    stockout: true,
    excess: true,
    supplierDelay: true,
    forecastDeviation: false,
    systemHealth: true,
    emailNotifications: false,
    slackNotifications: false,
    smsNotifications: false,
    webhookNotifications: false,
  });

  const handleInputChange = (e, key) => {
    setThresholds({ ...thresholds, [key]: e.target.value });
    console.log(`${key} threshold changed to`, e.target.value);
  };

  const toggleAlert = (key) => {
    setAlertToggles({ ...alertToggles, [key]: !alertToggles[key] });
    console.log(`${key} alert toggled to`, !alertToggles[key]);
  };

  const sectionStyle = {
    flex: 1,
    padding: 20,
    border: "1px solid #eee",
    borderRadius: 10,
    background: "#fff",
  };

  const labelStyle = {
    fontWeight: 500,
    marginTop: 10,
    marginBottom: 5,
    display: "block",
  };

  const inputStyle = {
    width: "100%",
    padding: 8,
    borderRadius: 6,
    border: "1px solid #ccc",
    marginBottom: 10,
  };


  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n")

  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [orderConformationSweetAlert,setOderConformationSweetAlert] = useState({
    show:false,

  })

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    if (basicTitle !== "Please fill all the fields"){
    localStorage.setItem('activeTab', "alerts");
    window.location.reload();
    }
   }

  
  useEffect(() => {
    const fetchData = async () => {
          setLoadshow("show-m");
          setOverlayBlock("show-m");
       try {
        const response = await redirectURL.post("inventory/fetchConfigurations", {});
        if (response.status === 200) {
            if (response.data.data.length > 0) {
              const data = response.data.data[0].alert_configurations ? JSON.parse(response.data.data[0].alert_configurations) : {};   
              if (Object.keys(data).length > 0) {  // Checking if data is not empty
                  setThresholds(data.thresholds)
                  setAlertToggles(data.alertToggles)
              }
            }
              setLoadshow("show-n");
              setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicTitle("Something Went Wrong");
          setBasicType("warning");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicTitle("Something Went Wrong");
        setBasicType("warning");
      }
    };

    fetchData();
  }, []); // Empty dependency array to run only once when the component mounts


  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const handleProcessConformation = async() => {
      setOderConformationSweetAlert({show:false})

      setLoadshow("show-m")
      setOverlayBlock("show-m")
      const data = JSON.stringify({
        alertToggles:alertToggles,
        thresholds:thresholds
      });
      const params = {
                    screenName :"alert_configurations",
                    data : data
          }
      const response = await redirectURL.post("inventory/saveConfigurations", params)
      if (response.status === 200){
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Configurations Successfully Saved");
              setBasicType("success");
      }
      else{
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Something Went Wrong");
              setBasicType("warning");
      }
  }
  
  const handleProcessCancel = () => {
      setOderConformationSweetAlert({show:false})
  }
  const saveConfigurations = async() => {
    setOderConformationSweetAlert({show:true})
    }


  return (
    <div style={{ padding: 20, fontFamily: "sans-serif" }}>
            <div style={{ zIndex: "9999999" }}>
                  <SweetAlert
                      show={show}
                      type={basicType}
                      title={basicTitle}
                      onConfirm={closeAlert}
                      style={{ fontSize: "9px" }}
                  >
                  </SweetAlert>
            </div>
            <div style={{ zIndex: "9999999" }}>
                
                <SweetAlert
                  show={orderConformationSweetAlert.show}
                  title="Are you sure?"
                  type="info"
                  showCancel
                  confirmBtnText="Yes"
                  cancelBtnText="No"
                  confirmBtnStyle={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                    fontWeight: "bold",
                    border: "none",
                    borderRadius: "4px",
                    padding: "6px 16px",
                    fontSize: "14px",
                  }}
                  cancelBtnStyle={{
                    backgroundColor: "#ea5e5e",
                    color: "#fff",
                    fontWeight: "bold",
                    border: "none",
                    borderRadius: "4px",
                    padding: "6px 16px",
                    fontSize: "14px",
                  }}
                  onConfirm={handleProcessConformation}
                  onCancel={handleProcessCancel}
                  focusCancelBtn
                >
                      Do you want to save Configurations?
                </SweetAlert>
            </div>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
        <AlertTriangle size={24} color="#ef4444" style={{ marginRight: 10 }} />
        <div>
          <h2 style={{ margin: 0 }}>Alerts & Thresholds</h2>
          <p style={{ margin: 0, color: "#6b7280" }}>
            Configure alert triggers and notification settings
          </p>
        </div>
      </div>

      {/* Two-Column Layout */}
      <div style={{ display: "flex", gap: 20, marginBottom: 24 }}>
        {/* Alert Thresholds */}
        <div style={sectionStyle}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
            <Bell size={18} style={{ marginRight: 6 }} />
            <h3 style={{ margin: 0 }}>Alert Thresholds</h3>
          </div>
          <p style={{ color: "#6b7280" }}>Set thresholds for automated alerts</p>

          <label style={labelStyle}>Low Stock Threshold (%)</label>
          <input
            type="number"
            value={thresholds.lowStock}
            onChange={(e) => handleInputChange(e, "lowStock")}
            style={inputStyle}
          />
          <small>Alert when stock falls below X% of max stock</small>

          <label style={labelStyle}>In-Transit Capacity Limit (%)</label>
          <input
            type="number"
            value={thresholds.inTransitLimit}
            onChange={(e) => handleInputChange(e, "inTransitLimit")}
            style={inputStyle}
          />
          <small>Max % of inventory allowed to be in-transit</small>

          <label style={labelStyle}>Order Delay Tolerance (hours)</label>
          <input
            type="number"
            value={thresholds.delayTolerance}
            onChange={(e) => handleInputChange(e, "delayTolerance")}
            style={inputStyle}
          />
          <small>Acceptable delay before re-routing orders</small>

          {/* <label style={labelStyle}>Forecast Accuracy Threshold (%)</label>
          <input
            type="number"
            value={thresholds.forecastAccuracy}
            onChange={(e) => handleInputChange(e, "forecastAccuracy")}
            style={inputStyle}
          /> */}
          {/* <small>Alert when forecast accuracy drops below threshold</small> */}
        </div>

        {/* Alert Categories */}
        <div style={sectionStyle}>
          <h3 style={{ marginTop: 0 }}>Alert Categories</h3>
          <p style={{ color: "#6b7280" }}>Enable/disable specific alert types</p>

          {[
            { label: "Stockout Alerts", desc: "Critical inventory shortage warnings", key: "stockout" },
            { label: "Excess Inventory Alerts", desc: "Overstock situation warnings", key: "excess" },
            { label: "Supplier Delay Alerts", desc: "Late delivery notifications", key: "supplierDelay" },
            // { label: "Forecast Deviation Alerts", desc: "Significant forecast vs actual variance", key: "forecastDeviation" },
            { label: "System Health Alerts", desc: "Technical issues and performance warnings", key: "systemHealth" },
          ].map((alert) => (
            <div
              key={alert.key}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}
            >
              <div>
                <strong>{alert.label}</strong>
                <p style={{ margin: 0, fontSize: 12, color: "#6b7280" }}>{alert.desc}</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={alertToggles[alert.key]}
                  onChange={() => toggleAlert(alert.key)}
                />
                <span
                  style={{
                    marginLeft: 10,
                    height: 24,
                    width: 42,
                    borderRadius: 9999,
                    background: alertToggles[alert.key] ? "#0f172a" : "#e5e7eb",
                    display: "inline-block",
                    position: "relative",
                    cursor: "pointer",
                    transition: "background 0.3s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 2,
                      left: alertToggles[alert.key] ? 22 : 2,
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      background: "#fff",
                      transition: "left 0.3s",
                    }}
                  />
                </span>
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Notification Channels - Full Width Row */}
      <div style={sectionStyle}>
        <h3 style={{ marginTop: 0, marginBottom: 24 }}>Notification Channels</h3>
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 32 }}>
          <div style={{ display: "flex", gap: 40 }}>
            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 400, fontSize: 15 }}>Email Notifications</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={alertToggles.emailNotifications || false}
                  onChange={() => setAlertToggles({ ...alertToggles, emailNotifications: !alertToggles.emailNotifications })}
                />
                <span
                  style={{
                    marginLeft: 10,
                    height: 32,
                    width: 56,
                    borderRadius: 9999,
                    background: alertToggles.emailNotifications ? "#0f172a" : "#e5e7eb",
                    display: "inline-block",
                    position: "relative",
                    cursor: "pointer",
                    transition: "background 0.3s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 4,
                      left: alertToggles.emailNotifications ? 30 : 4,
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      background: "#fff",
                      transition: "left 0.3s",
                    }}
                  />
                </span>
              </label>
            </div>
            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 400, fontSize: 15 }}>SMS Notifications</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={alertToggles.smsNotifications || false}
                  onChange={() => setAlertToggles({ ...alertToggles, smsNotifications: !alertToggles.smsNotifications })}
                />
                <span
                  style={{
                    marginLeft: 10,
                    height: 32,
                    width: 56,
                    borderRadius: 9999,
                    background: alertToggles.smsNotifications ? "#0f172a" : "#e5e7eb",
                    display: "inline-block",
                    position: "relative",
                    cursor: "pointer",
                    transition: "background 0.3s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 4,
                      left: alertToggles.smsNotifications ? 30 : 4,
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      background: "#fff",
                      transition: "left 0.3s",
                    }}
                  />
                </span>
              </label>
            </div>
          </div>
          <div style={{ display: "flex", gap: 40 }}>
            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 400, fontSize: 15 }}>Slack Notifications</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={alertToggles.slackNotifications || false}
                  onChange={() => setAlertToggles({ ...alertToggles, slackNotifications: !alertToggles.slackNotifications })}
                />
                <span
                  style={{
                    marginLeft: 10,
                    height: 32,
                    width: 56,
                    borderRadius: 9999,
                    background: alertToggles.slackNotifications ? "#0f172a" : "#e5e7eb",
                    display: "inline-block",
                    position: "relative",
                    cursor: "pointer",
                    transition: "background 0.3s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 4,
                      left: alertToggles.slackNotifications ? 30 : 4,
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      background: "#fff",
                      transition: "left 0.3s",
                    }}
                  />
                </span>
              </label>
            </div>
            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 400, fontSize: 15 }}>Webhook Notifications</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={alertToggles.webhookNotifications || false}
                  onChange={() => setAlertToggles({ ...alertToggles, webhookNotifications: !alertToggles.webhookNotifications })}
                />
                <span
                  style={{
                    marginLeft: 10,
                    height: 32,
                    width: 56,
                    borderRadius: 9999,
                    background: alertToggles.webhookNotifications ? "#0f172a" : "#e5e7eb",
                    display: "inline-block",
                    position: "relative",
                    cursor: "pointer",
                    transition: "background 0.3s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 4,
                      left: alertToggles.webhookNotifications ? 30 : 4,
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      background: "#fff",
                      transition: "left 0.3s",
                    }}
                  />
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
        <div className="col-sm-12 mt-2 mb-3" style={{textAlign: "right", display : "flex", justifyContent: "flex-end" }}>
            <button 
                onClick={() => { saveConfigurations() }}
                style={{
                  
                  padding: "10px 20px",
                  backgroundColor: "#991548",
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  cursor: "pointer",
                }}
                  >
                    Save All Configurations
            </button>
          </div>
          <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
          <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
            <div
            className={"overly-block " + overlyBlock}
            onClick={hideOverlySlideBlock}
          ></div>
    </div>
  );
};

export default AlertsSettings;
